// extracted by mini-css-extract-plugin
export default {"placeholder":"FileUploadDragger_placeholder__YXJQR","spanText":"FileUploadDragger_spanText__7tVbu"};